import React, { useEffect } from 'react';
import Alert from '@mui/material/Alert';
import AnalysisProgressLink from './AnalysisProgressLink';
import Button from '@mui/material/Button';
import { useVoyagerStore } from '../../stores/useVoyagerStore';
import type { LandingAgentTurn } from '../../stores/slices/landingAgentSlice';
import { stromaCompactPanel } from './askPresentation';

export default function DiagnosisProgress({ turn }: { turn: LandingAgentTurn }) {
  const resume = useVoyagerStore(s => s.resumeDiagnosis);
  const stop = useVoyagerStore(s => s.stopDiagnosis);
  const generation = useVoyagerStore(s => s.threadsGeneration);
  useEffect(() => {
    if ((turn.status === 'running' && !turn.stopped) || turn.diagnosisCancelPending) resume(turn.id);
  }, [resume, turn.id, turn.diagnosisOperationId, turn.status, turn.stopped, turn.diagnosisCancelPending, generation]);
  if (turn.diagnosisCancelPending) return <Alert severity="warning" sx={stromaCompactPanel}
    action={turn.diagnosisDisconnected ? <Button onClick={() => resume(turn.id)}>Reconnect</Button> : undefined}>
    Stop requested. Waiting for server confirmation.{turn.diagnosisDisconnected ? ' Reconnect to retry.' : ''}
  </Alert>;
  if (turn.stopped || (turn.status !== 'running' && !turn.diagnosisDisconnected)) return null;
  return <Alert severity={turn.diagnosisDisconnected ? 'warning' : 'info'} sx={stromaCompactPanel}
    action={turn.diagnosisDisconnected ? <Button onClick={() => resume(turn.id)}>Reconnect</Button> : <Button onClick={() => stop(turn.id)}>Stop</Button>}>
    {turn.diagnosisDisconnected ? turn.error :
      `Analysis ${turn.diagnosisProgress?.status === 'queued' ? 'queued' : 'running'} · ${turn.diagnosisProgress?.queries_completed || 0} queries completed. You can leave this tab and return to the same run.`}
    <AnalysisProgressLink turn={turn} />
  </Alert>;
}
